import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NzAvatarModule } from "ng-zorro-antd/avatar";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzDescriptionsModule } from "ng-zorro-antd/descriptions";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzInputNumberModule } from "ng-zorro-antd/input-number";
import { NzListModule } from "ng-zorro-antd/list";
import { NzMessageModule } from "ng-zorro-antd/message";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzPopconfirmModule } from "ng-zorro-antd/popconfirm";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { SharedModule } from "../../shared/shared.module";
import { DocumentssModule } from "../documents/documents.module";
import { CustomerMovimentsComponent } from "./customer-moviments/customer-moviments.component";
import { TransationsService } from "./service/transactions-api.service";
import { TransactionsDetailsComponent } from "./transactions-details/transactions-details.component";
import { TransactionsListComponent } from "./transactions-list/transactions-list.component";

@NgModule({
  declarations: [
    TransactionsListComponent,
    TransactionsDetailsComponent,
    CustomerMovimentsComponent,
  ],
  exports: [
    TransactionsListComponent,
    TransactionsDetailsComponent,
    CustomerMovimentsComponent,
  ],
  imports: [
    NzModalModule,
    CommonModule,
    NzDividerModule,
    NzAvatarModule,
    NzDescriptionsModule,
    NzMessageModule,
    NzDropDownModule,
    NzDatePickerModule,
    NzInputNumberModule,
    NzSpinModule,
    NzListModule,
    NzIconModule,
    NzCollapseModule,
    NzBadgeModule,
    NzTabsModule,
    SharedModule,
    RouterModule,
    NzTableModule,
    NzButtonModule,
    NzFormModule,
    NzSelectModule,
    NzInputModule,
    NzPopconfirmModule,
    FormsModule,
    DocumentssModule,
  ],
  providers: [TransationsService],
})
export class TransactionsModule {}
